import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledMetricsTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // color: "white",
    fontSize: 16,
    textTransform: "capitalize",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    borderCollapse: true,
    border: "none",
  },
}));

const StyledMetricsTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "black",
    color: "white",
    fontSize: 16,
    textTransform: "capitalize",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    borderCollapse: true,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#1F1F1F",
  color: "white",
}));

function MetricsTable({ metrics }) {
  return (
    <div>
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 700 }}
          aria-label="customized table"
          style={{ borderCollapse: "collapse" }}
        >
          <TableHead>
            <StyledTableRow>
              <StyledMetricsTableCell align="center">
                Name
              </StyledMetricsTableCell>
              <StyledMetricsTableCell align="center">
                Value
              </StyledMetricsTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {Object.keys(metrics).map((key, index) => (
              <StyledMetricsTableRow key={index}>
                <StyledTableCell align="center">{key}</StyledTableCell>
                <StyledTableCell align="center">{metrics[key]}</StyledTableCell>
              </StyledMetricsTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default MetricsTable;
